import { VStack } from 'ui_2';
import { ArcadeStoreFooter } from '../ArcadeStoreFooter';

export const pageXPadding = 'px-4 sm:px-8 md:px-16 lg:px-32 xl:px-48';

type Props = {
  children: React.ReactNode;
  showFooter?: boolean;
};

export const Body = ({ children, showFooter = true }: Props) => {
  return (
    <VStack
      className={`h-full w-full flex-1 items-center gap-8 overflow-y-auto pb-8 pt-4 md:pt-8 ${pageXPadding}`}
      style={
        {
          // viewTransitionName: 'partial',
          // contain: 'paint',
        }
      }
    >
      {children}
      {showFooter && <ArcadeStoreFooter />}
    </VStack>
  );
};
